import { createSelector } from 'reselect';
import { heroSectionMode, featuresRoute, landingRoute } from '../config/app';
import * as heroSectionModes from '../constants/heroSectionModes';

const getUI = state => state.ui;
const getUser = state => state.user;

export const isPageLoading = createSelector(
    [getUI],
    (ui) => {
        return ui.isLoginPending || ui.isScreenLoader;
    }
);


export const getCurrentAudio = createSelector(
    [getUI],
    (ui) => {
        if (!ui.currentPlayAudio) {
            return null;
        }

        return ui.currentPlayAudio;
    }
);

export const isVideoInto = createSelector(
    [getUI, getUser],
    (ui, user) => {
        if (document.location.pathname.indexOf(featuresRoute) < 0 && document.location.pathname.indexOf(landingRoute) < 0) {
            return false;
        }
        if (document.location.pathname.indexOf(featuresRoute) >= 0 && heroSectionMode !== heroSectionModes.MODE_VIDEO) {
            return false;
        }

        if (user.isLogged) {
            return false;
        }

        // to show intro for unlogged users
        return true;
    }
);
